import { Injectable } from '@angular/core';


@Injectable()
export class ChartHelper{

  backgroundColors = [
    '#2d7aba',
    '#785fa9',
    '#e17538',
    '#386b4f',
    '#46af49',
    '#f7d246',
    '#d13c3c',
    '#79d1ee',
    '#e6194b',
    '#3cb44b',
    '#ffe119',
    '#4363d8',
    '#f58231',
    '#911eb4',
    '#46f0f0',
    '#f032e6',
    '#bcf60c',
    '#fabebe',
    '#008080',
    '#e6beff',
    '#9a6324',
    '#fffac8',
    '#800000',
    '#aaffc3',
    '#808000',
    '#ffd8b1',
    '#000075',
    '#808080',
    '#000000'
  ];

  constructor(){
  }

  getChartResponse(response, question) {
    if (question.type === 'short_answer') {
      return this.getShortAnswer(response);
    }
    return {
      name: question.choices[response].text,
      value: response
    };
  }


  shortUrl(poll) {
    return poll.shortUrl.replace(/^https\:\/\//, '');
  }

  getShortAnswer(responses) {
    const validWords = responses;

    const wordCounts = {};
    validWords.forEach(word => {
      let w = word.userAnswer.replace(/^ | $/,'');
      let id = word.blankUID;
      let key = `${word.blankUID} - ${w}`;
      wordCounts[key] = wordCounts[key] && wordCounts[key].count ? { count: wordCounts[key].count + 1, label: w,  id }: { label: w, count: 1, id };
    });

    const numWords = Object.keys(wordCounts).length;
    return Object.keys(wordCounts).map((w, ndx) => {
      return {
        key:  wordCounts[w].label,
        id: wordCounts[w].id,
        value: wordCounts[w].count,
        color:
          ndx > numWords
            ? this.backgroundColors[ndx - numWords]
            : this.backgroundColors[ndx]
      };
    });
  }
}
